import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

/** 線條 icon，跟著按鈕文字顏色走；不用填色與漸層，維持後台的樸素風格 */
const PATHS: Record<string, ReactNode> = {
  back: <><path d="M10 6 4 12l6 6" /><path d="M4 12h16" /></>,
  edit: <><path d="M4 20h4L19 9l-4-4L4 16z" /><path d="m13.5 6.5 4 4" /></>,
  download: <><path d="M12 4v11" /><path d="m7 10 5 5 5-5" /><path d="M4 20h16" /></>,
  print: <><path d="M6 9V3h12v6" /><rect x="3" y="9" width="18" height="8" rx="1" /><path d="M7 14h10v7H7z" /></>,
  void: <><circle cx="12" cy="12" r="8.5" /><path d="m6 6 12 12" /></>,
}

export type IconName = keyof typeof PATHS

/**
 * 純 icon 按鈕。沒有文字，所以一定要給 tip：
 * 滑鼠移上去立刻顯示（瀏覽器內建的 title 要等約一秒，而且字很小），
 * 同時當作 aria-label 給螢幕閱讀器讀。
 */
export function IconButton({
  icon, tip, to, onClick, disabled, className,
}: {
  icon: IconName
  tip: string
  to?: string
  onClick?: () => void
  disabled?: boolean
  className?: string
}) {
  const btn = (
    <button
      type="button"
      className={`icon-btn${className ? ` ${className}` : ''}`}
      data-tip={tip}
      aria-label={tip}
      onClick={onClick}
      disabled={disabled}
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"
        strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{PATHS[icon]}</svg>
    </button>
  )
  return to ? <Link to={to} tabIndex={-1}>{btn}</Link> : btn
}
